import {SET_LOGS, CLEAR_LOGS, LOGS_INIT_STATE} from "./types";

export const logReducer = (state = LOGS_INIT_STATE, action) => {
    switch (action.type) {
        case SET_LOGS: return action.logs;
        case CLEAR_LOGS: return LOGS_INIT_STATE;
        default: return state
    }
}